import Story from "../../../../lib/html5-software-library/src/ranj/eng/story/engine/model/Story";
import ObjStoryParser from "../../../../lib/html5-software-library/src/ranj/eng/story/framework/serialization/ObjStoryParser";
import LanguagePack from "../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import { isString } from "../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import AssetLibrary from "../../core/assetloading/AssetLibrary";
import LanguagePackLoadedEvent from "../../core/language/controller/LanguagePackLoadedEvent";

/**
* StoryFactory.js
* 
* Created on 2-okt-2013, 16:51:34
*
* @author Ivo Swartjes for Ranj
**/
export default class NGTStoryFactory {

    /**
     * 
     * @param {AssetLibrary} assetLibrary 
     * @param {LanguagePack} languagePack 
     * @param {soma.EventDispatcher} dispatcher
     */
    constructor(assetLibrary, languagePack, dispatcher) {
        this.assetLibrary = assetLibrary;
        this.languagePack = languagePack;
        this.dispatcher = dispatcher;

        this.storyCache = {};
        this.storyParser = new ObjStoryParser(this.languagePack);
    }

    /**
     * 
     * @param {string} storyId 
     * @returns {Story}
     */
    getStory(storyId) {
        // first check is story is cached
        var story = this.storyCache[storyId];
        if (story) {
            return story;
        }
        // get story asset from asset library
        var storyAsset = this.assetLibrary.getAsset(storyId);
        if (!storyAsset) {
            return null;
        }
        // check if story asset is a raw string or Json object
        var jsonObj = isString(storyAsset) ? JSON.parse(storyAsset) : storyAsset;
        // check if json is the source story (.sty) or the story json
        var storyJson = this._isSourceStory(jsonObj) ? this._processSourceStory(storyId, jsonObj) : jsonObj;       
        // parse story
        story = this.storyParser.parseStory(storyJson);
        if (!story) {
            return null;
        }
        // cache it
        this.storyCache[storyId] = story;

        return story;
    }

    _isSourceStory(jsonObj){
        return jsonObj && jsonObj.hasOwnProperty('story');
    }

    /**
     * 
     * @param {{story: Object, lp: Object}} storySourceJson 
     * @returns {Object} story JSON
     */
    _processSourceStory(storyId, storySourceJson) {
        const storyJson = storySourceJson.story;
        const lpId = `${storyId}.lp`;
        // if no LP is present for this story, add the LP from the source story
        if(!this.assetLibrary.hasAsset(lpId)) {
            const lp = storySourceJson.lp;
            this.assetLibrary.addAsset(lpId, lp);

            const evt = new LanguagePackLoadedEvent(storyId, null, lp);
            this.dispatcher.dispatch(LanguagePackLoadedEvent.LOADED, { data: evt });
        }

        return storyJson;
    }
}


